export default {
  spendField: 'spend_ltd',
  interpolateMonths: true,
  trendMetrics: [
    {
      metric: 121,
      field: 'consideration',
      label: 'Lift to Consideration',
      format: '.0%',
      scale: [0, 0.6]

    },
    {
      metric: 122,
      field: 'impression',
      label: 'Lift to Brand Impression',
      format: '.0%',
      scale: [0, 0.6]
    },
  ]
};



// WEBPACK FOOTER //
// ./src/app/configuration/HEB/config/components/scorecard/Trendchart/index.js